const frTranslations = {
  // Common translations
  email: 'Email',
  
  // Common operations and UI elements
  common: {
    create: 'Créer',
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    view: 'Voir',
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    update: 'Mettre à jour',
    updating: 'Mise à jour en cours...',
    creating: 'Création en cours...',
    saveChanges: 'Enregistrer les modifications',
    saving: 'Enregistrement en cours...',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
    noData: 'Aucune donnée disponible',
    noItemsFound: 'Aucun élément trouvé',
    itemsPerPage: 'Éléments par page',
    search: 'Rechercher',
    actions: 'Actions',
    show: 'Afficher',
    entries: 'entrées',
    of: 'sur',
    retry: 'Réessayer',
    cannotDeleteAdmin: 'Impossible de supprimer un administrateur',
    page: 'Page',
    changeLanguage: 'Changer la langue',
    rowsPerPage: 'Lignes par page',
    applyFilters: 'Appliquer les filtres',
    clearFilters: 'Effacer les filtres',
    refresh: 'Rafraîchir',
    success: 'Succès',
    error: 'Erreur',
    warning: 'Avertissement',
    info: 'Information',
    loading: 'Chargement...',
    noOptions: 'Aucune option',
    optional: 'Optionnel',
    none: 'Aucun',
    back: 'Retour',
    selectOption: 'Sélectionner une option',
    selectUser: 'Sélectionner un utilisateur',
    // Delete confirmation dialog
    deleteDialog: {
      cancel: 'Annuler',
      delete: 'Supprimer',
      title: 'Confirmer la suppression',
      content: 'Êtes-vous sûr de vouloir supprimer cet élément ? Cette action est irréversible.'
    }
  },
  
  login: {
    title: 'Connexion',
    email: 'Email',
    password: 'Mot de passe',
    submit: 'Se connecter',
    error: 'Email ou mot de passe incorrect',
    forgotPassword: 'Mot de passe oublié ?',
  },
  
  // Validation messages
  validation: {
    required: '{{field}} est requis',
    email: 'Veuillez entrer une adresse email valide',
    emailExists: 'Un utilisateur avec cet email existe déjà',
    passwordLength: 'Le mot de passe doit contenir au moins {{min}} caractères',
    passwordsDontMatch: 'Les mots de passe ne correspondent pas',
    minLength: 'Doit contenir au moins {{min}} caractères',
    maxLength: 'Ne doit pas dépasser {{max}} caractères',
    invalidFormat: 'Format invalide',
    number: 'Doit être un nombre',
    min: 'Doit être au moins {{min}}',
    max: 'Ne doit pas dépasser {{max}}',
    invalidPhone: 'Veuillez entrer un numéro de téléphone valide',
    phoneFormat: 'Format: XX XX XX XX (8 chiffres)'
  },

  // Error messages
  errors: {
    loadData: 'Échec du chargement des données',
    saveData: 'Échec de l\'enregistrement des données',
    deleteData: 'Échec de la suppression des données',
    loadUser: 'Échec du chargement des données utilisateur',
    saveUser: 'Échec de l\'enregistrement de l\'utilisateur. Veuillez réessayer.',
    deleteUser: 'Échec de la suppression de l\'utilisateur',
    unauthorized: 'Vous n\'êtes pas autorisé à effectuer cette action',
    notFound: 'La ressource demandée est introuvable',
    serverError: 'Une erreur serveur est survenue',
    networkError: 'Erreur réseau. Veuillez vérifier votre connexion.'
  },

  // Drivers module
  drivers: {
    title: 'Chauffeurs',
    name: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    status: 'Statut',
    vehicleType: 'Type de véhicule',
    vehicleNumber: 'Numéro de véhicule',
    addDriver: 'Ajouter un chauffeur',
    editDriver: 'Modifier le chauffeur',
    driverInfo: 'Informations du chauffeur',
    activity: 'Activité récente',
    noActivity: 'Aucune activité récente',
    form: {
      name: 'Nom complet',
      email: 'Adresse email',
      phone: 'Numéro de téléphone',
      password: 'Mot de passe',
      vehicleType: 'Type de véhicule',
      vehicleNumber: 'Numéro d\'immatriculation du véhicule',
      licenseNumber: 'Numéro de permis de conduire',
      currentLocation: 'Ville actuelle',
      rating: 'Note',
      totalDeliveries: 'Total des livraisons',
    },
    deleteDialog: {
      title: 'Supprimer le chauffeur',
      content: 'Êtes-vous sûr de vouloir supprimer ce chauffeur ? Cette action est irréversible.',
      cancel: 'Annuler',
      delete: 'Supprimer',
    },
    statusUpdate: {
      title: 'Mettre à Jour Mon Statut',
      currentStatus: 'Statut Actuel :',
      updateButton: 'Mettre à Jour le Statut',
      updating: 'Mise à jour...',
      success: 'Statut mis à jour avec succès !',
      error: 'Échec de la mise à jour du statut. Veuillez réessayer.',
      noUserError: "Impossible d'identifier l'utilisateur actuel.",
      locationPlaceholder: 'Entrez votre localisation actuelle (optionnel)',
      locationHelper: 'Cela aide les clients à suivre les livraisons'
    },
    statuses: {
      active: 'Actif',
      inactive: 'Inactif',
      available: 'Disponible',
      on_delivery: 'En livraison'
    },
    vehicleTypes: {
      bike: 'Vélo',
      bicycle: 'Vélo',
      scooter: 'Scooter',
      motorcycle: 'Moto',
      car: 'Voiture',
      van: 'Camionnette',
      truck: 'Camion'
    },
    filters: {
      active: 'Actifs',
      inactive: 'Inactifs',
      onDelivery: 'En livraison'
    },
    notFound: 'Chauffeur non trouvé',
    backToDrivers: 'Retour aux chauffeurs',
    passwordRequirements: 'Le mot de passe doit contenir au moins 8 caractères'
  },

  // Users module
  users: {
    title: 'Utilisateurs',
    name: 'Nom',
    email: 'Email',
    role: 'Rôle',
    actions: 'Actions',
    edit: 'Modifier',
    delete: 'Supprimer',
    create: 'Créer un utilisateur',
    save: 'Enregistrer',
    cancel: 'Annuler',
    form: {
      name: 'Nom complet',
      email: 'Adresse email',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      role: 'Rôle',
      phone: 'Téléphone',
      address: 'Adresse'
    },
    roles: {
      admin: 'Administrateur',
      driver: 'Chauffeur',
      client: 'Client'
    },
    deleteDialog: {
      title: 'Supprimer l\'utilisateur',
      content: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.'
    },
    clientPasswordInfo: 'Les utilisateurs clients ne nécessitent pas de mot de passe et ne peuvent pas se connecter au tableau de bord administrateur. Ils peuvent uniquement suivre les expéditions via le portail de suivi public.',
  },
  
  dashboard: {
    title: 'Tableau de bord administrateur',
    welcome: 'Bienvenue',
    logout: 'Déconnexion',
    overview: 'Aperçu',
    profile: 'Profil',
    settings: 'Paramètres',
    accountSettings: 'Paramètres du compte',
    
    // Admin dashboard
    totalShipments: 'Total des expéditions',
    activeDrivers: 'Chauffeurs actifs',
    monthlyRevenue: 'Revenus mensuels',
    pendingShipments: 'Expéditions en attente',
    revenueChart: 'Tendances des revenus',
    shipmentDistribution: 'Distribution des expéditions',
    driversOverview: 'Aperçu des chauffeurs',
    recentActivities: 'Activités récentes',
    viewAllReports: 'Voir tous les rapports',
    manageUsers: 'Gérer les utilisateurs',
    systemHealth: 'État du système',
    
    // Driver dashboard
    totalDeliveries: 'Total des livraisons',
    todaysDeliveries: 'Livraisons d\'aujourd\'hui',
    currentStatus: 'Statut actuel',
    rating: 'Note',
    todaysEarnings: 'Gains d\'aujourd\'hui',
    thisWeek: 'Cette semaine',
    thisMonth: 'Ce mois',
    activeShipments: 'Expéditions actives',
    updateLocation: 'Mettre à jour la localisation',
    viewAssignments: 'Voir les assignations',
    yourRecentActivities: 'Vos activités récentes',
    shipmentsAssigned: 'expéditions assignées',
    keepCustomersInformed: 'Tenir les clients informés',
    tapToChange: 'Appuyer pour changer',
    customerRating: 'Note client',
    vsYesterday: 'vs hier',
    available: 'Disponible',
    busy: 'Occupé',
    offline: 'Hors ligne',
    
    // Common
    loading: 'Chargement du tableau de bord...',
    error: 'Erreur lors du chargement des données',
    retry: 'Réessayer',
    goodMorning: 'Bonjour',
    goodAfternoon: 'Bon après-midi',
    goodEvening: 'Bonsoir'
  },
  
  menu: {
    dashboard: 'Tableau de bord',
    users: 'Utilisateurs',
    customers: 'Clients',
    drivers: 'Chauffeurs',
    shipments: 'Expéditions',
    quotes: 'Devis',
    zones: 'Zones',
    reports: 'Rapports',
    staff: 'Équipe',
  },

  // Module Devis
  quotes: {
    title: 'Devis',
    list: {
      title: 'Gestion des Devis',
      subtitle: 'Gérer les devis de livraison et les demandes de tarification',
      noQuotes: 'Aucun devis trouvé',
      loading: 'Chargement des devis...',
      error: 'Échec du chargement des devis',
    },
    detail: {
      title: 'Détails du Devis',
      backToQuotes: 'Retour aux Devis',
      deleteQuote: 'Supprimer le Devis',
      reference: 'Référence',
      status: 'Statut',
      createdAt: 'Créé le',
      updatedAt: 'Mis à jour le',
      loading: 'Chargement du devis...',
      error: 'Échec du chargement du devis',
      notFound: 'Devis non trouvé',
    },
    status: {
      pending: 'En attente',
      reviewed: 'Examiné',
      approved: 'Approuvé',
      rejected: 'Rejeté',
      all: 'Tous les statuts',
      management: 'Gestion du Statut',
      update: 'Mettre à jour le Statut',
      updating: 'Mise à jour...',
      notes: 'Notes (optionnel)',
      notesPlaceholder: 'Ajouter des notes sur ce changement de statut...',
      updateSuccess: 'Statut du devis mis à jour avec succès',
      updateError: 'Échec de la mise à jour du statut du devis',
      current: 'Statut Actuel',
    },
    delete: {
      title: 'Supprimer le Devis',
      message: 'Êtes-vous sûr de vouloir supprimer le devis',
      warning: 'Cette action ne peut pas être annulée.',
      confirm: 'Supprimer',
      cancel: 'Annuler',
      deleting: 'Suppression...',
      success: 'Devis supprimé avec succès',
      error: 'Échec de la suppression du devis',
    },
    sender: {
      title: 'Informations de l\'Expéditeur',
      name: 'Nom',
      phone: 'Téléphone',
      address: 'Adresse',
    },
    recipient: {
      title: 'Informations du Destinataire',
      name: 'Nom',
      phone: 'Téléphone',
      address: 'Adresse',
    },
    package: {
      title: 'Informations du Colis',
      type: 'Type',
      weight: 'Poids',
      dimensions: 'Dimensions',
      value: 'Valeur',
      description: 'Description',
    },
    delivery: {
      title: 'Informations de Livraison',
      service: 'Type de Service',
      date: 'Date de Livraison',
      time: 'Heure de Livraison',
      instructions: 'Instructions',
      zone: 'Zone',
      estimatedDays: 'Jours Estimés',
    },
    pricing: {
      title: 'Informations de Tarification',
      pricePerKg: 'Prix par KG',
      totalPrice: 'Prix Total',
      currency: 'Devise',
    },
    filters: {
      search: 'Rechercher des devis...',
      status: 'Filtrer par Statut',
      apply: 'Appliquer les Filtres',
      clear: 'Effacer les Filtres',
    },
    pagination: {
      page: 'Page',
      of: 'sur',
      rowsPerPage: 'Lignes par page',
      previous: 'Précédent',
      next: 'Suivant',
    },
    actions: {
      view: 'Voir',
      edit: 'Modifier',
      delete: 'Supprimer',
      updateStatus: 'Mettre à jour le Statut',
    },
  },

  // Shipments module
  shipments: {
    title: 'Expéditions',
    create: {
      title: 'Créer une expédition',
      subtitle: 'Remplissez les détails de l\'expédition'
    },
    createNew: 'Nouvelle expédition',
    editShipment: 'Modifier l\'expédition',
    trackingNumber: 'Numéro de suivi',
    customer: 'Client',
    driver: 'Chauffeur',
    origin: 'Origine',
    destination: 'Destination',
    weight: 'Poids',
    dimensions: 'Dimensions',
    price: 'Prix',
    status: 'Statut',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    deliveredAt: 'Livré le',
    estimatedDelivery: 'Livraison estimée',
    actualDelivery: 'Livraison réelle',
    notes: 'Notes',
    description: 'Description',
    // Status options
    statuses: {
      pending: 'En attente',
      in_transit: 'En transit',
      out_for_delivery: 'En cours de livraison',
      delivered: 'Livré',
      exception: 'Problème signalé',
      returned: 'Retourné à l\'expéditeur',
      all: 'Tous les statuts'
    },
    
    // Actions
    actions: {
      updateStatus: 'Mettre à jour le statut',
      assignDriver: 'Assigner un chauffeur',
      addNote: 'Ajouter une note',
      create: 'Créer une expédition',
      edit: 'Modifier',
      delete: 'Supprimer',
      view: 'Voir',
      track: 'Suivre',
      printLabel: 'Imprimer l\'étiquette',
      markAsDelivered: 'Marquer comme livré'
    },
    
    // Error messages
    errors: {
      invalidTrackingNumber: 'Numéro de suivi invalide',
      trackingNumberMissing: 'Le numéro de suivi est manquant ou invalide. Veuillez vérifier l\'URL et réessayer.'
    },
    
    // Messages
    messages: {
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette expédition ?',
      deleted: 'Expédition supprimée avec succès',
      deleteError: 'Échec de la suppression de l\'expédition',
      loading: 'Chargement des expéditions...',
      noShipments: 'Aucune expédition trouvée',
      created: 'Expédition créée avec succès',
      updated: 'Expédition mise à jour avec succès',
      statusUpdated: 'Statut mis à jour avec succès',
      assignedDriver: 'Chauffeur assigné avec succès',
      noteAdded: 'Note ajoutée avec succès',
      createError: 'Échec de la création de l\'expédition',
      updateError: 'Échec de la mise à jour de l\'expédition',
      statusUpdateError: 'Échec de la mise à jour du statut',
      assignDriverError: 'Échec de l\'assignation du chauffeur',
      addNoteError: 'Échec de l\'ajout de la note',
      loadError: 'Erreur lors du chargement des expéditions',
      notFound: 'Expédition non trouvée',
      trackingError: 'Erreur lors du suivi de l\'expédition'
    },
    
    // Field labels
    fields: {
      id: 'ID',
      trackingNumber: 'Numéro de suivi',
      status: 'Statut',
      origin: 'Origine (Ville)',
      destination: 'Destination (Ville)',
      customer: 'Client',
      driver: 'Agent de livraison',
      weight: 'Poids (kg)',
      dimensions: 'Dimensions',
      price: 'Prix',
      totalPrice: 'Prix total',
      createdAt: 'Créé le',
      updatedAt: 'Mis à jour le',
      deliveredAt: 'Livré le',
      estimatedDelivery: 'Livraison estimée',
      notes: 'Notes',
      description: 'Description',
      senderName: 'Nom de l\'expéditeur',
      senderPhone: 'Téléphone de l\'expéditeur',
      senderAddress: 'Adresse de l\'expéditeur',
      senderCity: 'Ville',
      senderCountry: 'Pays',
      senderPostalCode: 'Code postal',
      receiverName: 'Nom du destinataire',
      receiverPhone: 'Téléphone du destinataire',
      receiverAddress: 'Adresse de livraison',
      receiverCity: 'Ville',
      receiverCountry: 'Pays',
      receiverPostalCode: 'Code postal',
      zone: 'Zone de livraison'
    },
    
    // Filtering and searching
    filter: {
      all: 'Toutes les expéditions',
      today: 'Aujourd\'hui',
      thisWeek: 'Cette semaine',
      thisMonth: 'Ce mois',
      dateRange: 'Plage de dates',
      status: 'Filtrer par statut',
      customer: 'Filtrer par client',
      driver: 'Filtrer par chauffeur',
      origin: 'Filtrer par origine',
      destination: 'Filtrer par destination',
      searchPlaceholder: 'Rechercher par numéro de suivi, client, etc.',
      noResults: 'Aucun résultat trouvé pour votre recherche',
      clearSearch: 'Effacer la recherche'
    },
    
    // Tracking
    tracking: {
      title: 'Suivi de l\'expédition',
      trackingNumber: 'Numéro de suivi',
      currentStatus: 'Statut actuel',
      currentLocation: 'Localisation actuelle',
      estimatedDelivery: 'Livraison estimée',
      history: 'Historique de suivi',
      noHistory: 'Aucun historique de suivi disponible',
      timestamp: 'Horodatage',
      event: 'Événement',
      notes: 'Notes'
    }
  },

  // Zones module
  zones: {
    title: 'Zones d\'expédition',
    createNew: 'Nouvelle zone',
    editZone: 'Modifier la zone',
    
    // Field labels
    fields: {
      id: 'ID',
      name: 'Nom de la zone',
      region: 'Région',
      pricePerKg: 'Prix par kg',
      description: 'Description',
      isActive: 'Active',
      createdAt: 'Créé le',
      updatedAt: 'Mis à jour le',
      cities: 'Villes couvertes',
      deliveryTime: 'Temps de livraison (jours)',
      minWeight: 'Poids minimum (kg)',
      maxWeight: 'Poids maximum (kg)',
      additionalFees: 'Frais supplémentaires'
    },
    
    // Form labels
    form: {
      name: 'Nom de la zone',
      region: 'Région',
      pricePerKg: 'Prix par kilogramme (XOF)',
      description: 'Description de la zone',
      isActive: 'Zone active',
      cities: 'Villes couvertes (séparées par des virgules)',
      deliveryTime: 'Temps de livraison estimé (jours)',
      minWeight: 'Poids minimum (kg)',
      maxWeight: 'Poids maximum (kg)',
      additionalFees: 'Frais supplémentaires (XOF)'
    },
    
    // Status
    status: {
      active: 'Active',
      inactive: 'Inactive'
    },
    
    // Actions
    actions: {
      create: 'Créer une zone',
      edit: 'Modifier',
      delete: 'Supprimer',
      activate: 'Activer',
      deactivate: 'Désactiver',
      view: 'Voir les détails'
    },
    
    // Messages
    messages: {
      loading: 'Chargement des zones...',
      error: 'Erreur lors du chargement des zones',
      noZones: 'Aucune zone trouvée',
      created: 'Zone créée avec succès',
      updated: 'Zone mise à jour avec succès',
      deleted: 'Zone supprimée avec succès',
      createError: 'Échec de la création de la zone',
      updateError: 'Échec de la mise à jour de la zone',
      deleteError: 'Échec de la suppression de la zone'
    },
    
    // Delete confirmation
    deleteDialog: {
      title: 'Supprimer la zone',
      content: 'Êtes-vous sûr de vouloir supprimer la zone "{{name}}" ? Cette action est irréversible.'
    }
  },

  // Customers module
  customers: {
    title: 'Clients',
    createNew: 'Nouveau client',
    createCustomer: 'Créer un client',
    editCustomer: 'Modifier le client',
    searchPlaceholder: 'Rechercher des clients...',
    noCustomers: 'Aucun client trouvé',
    noSearchResults: 'Aucun client ne correspond à votre recherche',
    
    // Field labels
    fields: {
      id: 'ID',
      user: 'Compte utilisateur',
      companyName: 'Nom de l\'entreprise',
      contactPerson: 'Personne de contact',
      phone: 'Numéro de téléphone',
      alternatePhone: 'Téléphone alternatif',
      email: 'Email',
      website: 'Site web',
      status: 'Statut',
      notes: 'Notes',
      totalShipments: 'Total des expéditions',
      totalSpent: 'Total dépensé',
      lastShipment: 'Dernière expédition',
      createdAt: 'Créé le',
      updatedAt: 'Mis à jour le',
      addressType: 'Type d\'adresse',
      addressLabel: 'Libellé de l\'adresse',
      addressLine1: 'Ligne d\'adresse 1',
      addressLine2: 'Ligne d\'adresse 2',
      city: 'Ville',
      state: 'État',
      postalCode: 'Code postal',
      country: 'Pays'
    },
    
    // Status options
    status: {
      active: 'Actif',
      inactive: 'Inactif',
      suspended: 'Suspendu'
    },
    
    // Address types
    addressType: {
      billing: 'Facturation',
      shipping: 'Livraison',
      both: 'Les deux'
    },
    
    // Statistics
    stats: {
      totalCustomers: 'Total des clients',
      activeCustomers: 'Clients actifs',
      inactiveCustomers: 'Clients inactifs',
      totalRevenue: 'Chiffre d\'affaires total',
      averageOrderValue: 'Valeur moyenne des commandes'
    },
    
    // Sections
    sections: {
      companyInfo: 'Informations de l\'entreprise',
      statistics: 'Statistiques du client',
      addresses: 'Adresses',
      shipmentHistory: 'Historique des expéditions'
    },
    
    // Actions
    addAddress: 'Ajouter une adresse',
    editAddress: 'Modifier l\'adresse',
    defaultAddress: 'Par défaut',
    noAddresses: 'Aucune adresse trouvée',
    noShipments: 'Aucune expédition trouvée',
    
    // Messages
    messages: {
      created: 'Client créé avec succès',
      updated: 'Client mis à jour avec succès',
      deleted: 'Client supprimé avec succès',
      addressAdded: 'Adresse ajoutée avec succès',
      addressUpdated: 'Adresse mise à jour avec succès',
      addressDeleted: 'Adresse supprimée avec succès',
      loadError: 'Échec du chargement des données client',
      shipmentsLoadError: 'Échec du chargement des expéditions du client',
      createError: 'Échec de la création du client',
      updateError: 'Échec de la mise à jour du client',
      deleteError: 'Échec de la suppression du client',
      addressAddError: 'Échec de l\'ajout de l\'adresse',
      addressUpdateError: 'Échec de la mise à jour de l\'adresse',
      addressDeleteError: 'Échec de la suppression de l\'adresse',
      loadUsersError: 'Échec du chargement des utilisateurs',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer {{name}} ?',
      notFound: 'Client non trouvé',
      error: 'Erreur lors du chargement des clients'
    }
  },
  
  // Access control translations
  access: {
    denied: 'Accès refusé',
    driverRestriction: 'En tant que chauffeur, vous ne pouvez accéder qu\'au tableau de bord et aux pages de gestion des chauffeurs. Les autres pages sont réservées aux administrateurs uniquement.',
    allowedPages: 'Pages autorisées',
    goToDashboard: 'Aller au tableau de bord'
  },

  // CRUD translations (top-level for components using t('crud.*'))
  crud: {
    create: 'Créer',
    actions: 'Actions',
    edit: 'Modifier',
    delete: 'Supprimer',
    cannotDeleteAdmin: 'Impossible de supprimer un utilisateur administrateur'
  }
};

export default frTranslations;
/* Duplicate French translation content below is commented out temporarily to fix syntax errors during build.

  // Common translations
  email: 'Email',
  
  // Common operations and UI elements
  common: {
    create: 'Créer',
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    view: 'Voir',
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    update: 'Mettre à jour',
    updating: 'Mise à jour en cours...',
    creating: 'Création en cours...',
    saveChanges: 'Enregistrer les modifications',
    saving: 'Enregistrement en cours...',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
    noData: 'Aucune donnée disponible',
    noItemsFound: 'Aucun élément trouvé',
    itemsPerPage: 'Éléments par page',
    search: 'Rechercher',
    actions: 'Actions',
    show: 'Afficher',
    entries: 'entrées',
    of: 'sur',
    retry: 'Réessayer',
    cannotDeleteAdmin: 'Impossible de supprimer un administrateur',
    page: 'Page',
    rowsPerPage: 'Lignes par page',
    applyFilters: 'Appliquer les filtres',
    clearFilters: 'Effacer les filtres',
    refresh: 'Rafraîchir',
    success: 'Opération réussie',
    error: 'Erreur',
    warning: 'Avertissement',
    info: 'Information',
    loading: 'Chargement...',
    noOptions: 'Aucune option',
    yes: 'Oui',
    no: 'Non',
    deleting: 'Suppression en cours...',
    changeLanguage: 'Changer la langue',
    user: 'Utilisateur',
    optional: 'Optionnel',
    none: 'Aucun',
    back: 'Retour',
    selectOption: 'Sélectionner une option',
    selectUser: 'Sélectionner un utilisateur',
    backToShipments: 'Retour aux expéditions',
    searchTerm: 'Terme de recherche',
    searchingFor: 'Recherche en cours',
    unexpectedResponse: 'Format de réponse inattendu du serveur',
    networkError: 'Échec du chargement des données. Veuillez vérifier votre connexion et réessayer.',
    
    // CRUD operations
    crud: {
      create: 'Créer',
      edit: 'Modifier',
      delete: 'Supprimer',
      view: 'Voir',
      actions: 'Actions',
      cancel: 'Annuler',
      save: 'Enregistrer',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
      cannotDeleteAdmin: 'Impossible de supprimer un administrateur',
      createSuccess: 'Création réussie',
      updateSuccess: 'Mise à jour réussie',
      deleteSuccess: 'Suppression réussie',
      error: 'Erreur lors de l\'opération',
      noData: 'Aucune donnée disponible',
      loading: 'Chargement...',
      search: 'Rechercher',
      filter: 'Filtrer',
      refresh: 'Rafraîchir',
      back: 'Retour'
    },
    notFound: 'Non trouvé',
    notSpecified: 'Non spécifié',
    notAssigned: 'Non assigné',
    // Delete confirmation dialog
    deleteDialog: {
      cancel: 'Annuler',
      delete: 'Supprimer',
      title: 'Confirmer la suppression',
      content: 'Êtes-vous sûr de vouloir supprimer cet élément ? Cette action est irréversible.'
    }
  },
  login: {
    title: 'Connexion',
    email: 'Email',
    password: 'Mot de passe',
    submit: 'Se connecter',
    error: 'Email ou mot de passe incorrect',
    forgotPassword: 'Mot de passe oublié ?',
  },
  // Validation messages
  validation: {
    required: '{{field}} est requis',
    email: 'Veuillez entrer une adresse email valide',
    emailExists: 'Un utilisateur avec cette adresse email existe déjà',
    passwordLength: 'Le mot de passe doit contenir au moins {{min}} caractères',
    passwordsDontMatch: 'Les mots de passe ne correspondent pas',
    minLength: 'Doit contenir au moins {{min}} caractères',
    maxLength: 'Ne doit pas dépasser {{max}} caractères',
    invalidFormat: 'Format invalide',
    number: 'Doit être un nombre',
    min: 'Doit être au moins {{min}}',
    max: 'Ne doit pas dépasser {{max}}',
    invalidPhone: 'Veuillez entrer un numéro de téléphone valide',
    phoneFormat: 'Format: XX XX XX XX (8 chiffres)'
  },

  // Error messages
  errors: {
    loadData: 'Échec du chargement des données',
    saveData: 'Échec de l\'enregistrement des données',
    deleteData: 'Échec de la suppression des données',
    loadUser: 'Échec du chargement des données utilisateur',
    saveUser: 'Échec de l\'enregistrement de l\'utilisateur. Veuillez réessayer.',
    deleteUser: 'Échec de la suppression de l\'utilisateur',
    unauthorized: 'Vous n\'êtes pas autorisé à effectuer cette action',
    notFound: 'La ressource demandée est introuvable',
    serverError: 'Une erreur serveur est survenue',
    networkError: 'Erreur réseau. Veuillez vérifier votre connexion.'
  },

  // Drivers module
  drivers: {
    title: 'Conducteurs',
    name: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    status: 'Statut',
    vehicleType: 'Type de véhicule',
    vehicleNumber: 'Numéro de véhicule',
    addDriver: 'Ajouter un conducteur',
    editDriver: 'Modifier le conducteur',
    driverInfo: 'Informations du conducteur',
    activity: 'Activité récente',
    noActivity: 'Aucune activité récente',
    deleteDialog: {
      title: 'Supprimer le conducteur',
      content: 'Êtes-vous sûr de vouloir supprimer ce conducteur ? Cette action est irréversible.'
    },
    statusUpdate: {
      title: 'Mettre à Jour Mon Statut',
      currentStatus: 'Statut Actuel :',
      updateButton: 'Mettre à Jour le Statut',
      updating: 'Mise à jour...',
      success: 'Statut mis à jour avec succès !',
      error: 'Échec de la mise à jour du statut. Veuillez réessayer.',
      noUserError: 'Impossible d\'identifier l\'utilisateur actuel.',
      locationPlaceholder: 'Entrez votre localisation actuelle (optionnel)',
      locationHelper: 'Cela aide les clients à suivre les livraisons'
    },
    statuses: {
      active: 'Actif',
      inactive: 'Inactif',
      available: 'Disponible',
      on_delivery: 'En livraison'
    },
    form: {
      name: 'Nom complet',
      email: 'Adresse email',
      phone: 'Numéro de téléphone',
      password: 'Mot de passe',
      vehicleType: 'Type de véhicule',
      vehicleNumber: 'Numéro d\'immatriculation du véhicule',
      licenseNumber: 'Numéro de permis de conduire',
      currentLocation: 'Ville actuelle',
      rating: 'Note',
      totalDeliveries: 'Total des livraisons'
    },
    vehicleTypes: {
      bike: 'Vélo',
      bicycle: 'Vélo', // Alias for bike
      scooter: 'Scooter',
      motorcycle: 'Moto',
      car: 'Voiture',
      truck: 'Camion',
      van: 'Fourgonnette'
    },
    stats: {
      total: 'Total des chauffeurs',
      active: 'Actifs',
      inactive: 'Inactifs',
      onDelivery: 'En livraison'
    },
    notFound: 'Chauffeur non trouvé',
    backToDrivers: 'Retour aux chauffeurs',
    passwordRequirements: 'Le mot de passe doit contenir au moins 8 caractères'
  },

  // Users module
  users: {
    title: 'Utilisateurs',
    name: 'Nom',
    email: 'Email',
    role: 'Rôle',
    actions: 'Actions',
    edit: 'Modifier',
    delete: 'Supprimer',
    create: 'Créer un utilisateur',
    save: 'Enregistrer',
    cancel: 'Annuler',
    createTitle: 'Créer un nouvel utilisateur',
    editTitle: 'Modifier l\'utilisateur',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
    password: 'Mot de passe',
    newPassword: 'Nouveau mot de passe (laisser vide pour conserver l\'actuel)',
    confirmPassword: 'Confirmer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    changePassword: 'Changer le mot de passe',
    passwordRequirements: 'Le mot de passe doit contenir au moins 8 caractères',
    selectRole: 'Sélectionner un rôle',
    resetPassword: 'Réinitialiser le mot de passe',
    createdAt: 'Créé le',
    roles: {
      admin: 'Administrateur',
      driver: 'Chauffeur',
      client: 'Client'
    },
    clientPasswordInfo: 'Les utilisateurs clients ne nécessitent pas de mot de passe et ne peuvent pas se connecter au tableau de bord administrateur. Ils peuvent uniquement suivre les expéditions via le portail de suivi public.',
  },

  menu: {
    dashboard: 'Tableau de bord',
    users: 'Utilisateurs',
    customers: 'Clients',
    drivers: 'Chauffeurs',
    shipments: 'Expéditions',
    quotes: 'Devis',
    zones: 'Zones',
    reports: 'Rapports',
    staff: 'Équipe',
  },

  // Shipments module
  shipments: {
    title: 'Expéditions',
    create: {
      title: 'Créer une expédition',
      subtitle: 'Remplissez les détails de la nouvelle expédition'
    },
    createNew: 'Nouvelle expédition',
    editShipment: 'Modifier l\'expédition',
    trackingNumber: 'Numéro de suivi',
    originCity: 'Ville d\'origine',
    destinationCity: 'Ville de destination',
    customer: 'Client',
    driver: 'Agent de livraison',
    weight: 'Poids (kg)',
    dimensions: 'Dimensions',
    value: 'Valeur déclarée',
    description: 'Description',
    notes: 'Notes',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    estimatedDelivery: 'Livraison estimée',
    actualDelivery: 'Livraison réelle',
    
    // Status options
    statuses: {
      pending: 'En attente',
      confirmed: 'Confirmé',
      picked_up: 'Collecté',
      in_transit: 'En transit',
      out_for_delivery: 'Avec l\'agent de livraison',
      delivered: 'Livré',
      exception: 'Problème signalé',
      returned: 'Retourné à l\'expéditeur',
      all: 'Tous les statuts'
    },
    
    // Actions
    actions: {
      updateStatus: 'Mettre à jour le statut',
      assignDriver: 'Assigner un chauffeur',
      addNote: 'Ajouter une note',
      create: 'Créer une expédition',
      edit: 'Modifier',
      delete: 'Supprimer',
      view: 'Voir',
      track: 'Suivre',
      printLabel: 'Imprimer l\'étiquette',
      markAsDelivered: 'Marquer comme livré'
    },
    
    // Error messages
    errors: {
      invalidTrackingNumber: 'Numéro de suivi invalide',
      trackingNumberMissing: 'Le numéro de suivi est manquant ou invalide. Veuillez vérifier l\'URL et réessayer.'
    },
    
    // Messages
    messages: {
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette expédition ?',
      deleted: 'Expédition supprimée avec succès',
      deleteError: 'Échec de la suppression de l\'expédition',
      loading: 'Chargement des expéditions...',
      error: 'Erreur lors du chargement des expéditions',
      retry: 'Réessayer',
      createSuccess: 'Expédition créée avec succès',
      updateSuccess: 'Expédition mise à jour avec succès',
      updated: 'Expédition mise à jour avec succès',
      updateError: 'Échec de la mise à jour de l\'expédition',
      deleteSuccess: 'Expédition supprimée avec succès',
      noShipments: 'Aucune expédition trouvée',
      searchingFor: 'Recherche en cours pour',
      resetFilters: 'Réinitialiser tous les filtres',
      loadingShipments: 'Chargement des expéditions...',
      shipmentsLoaded: 'Expéditions chargées avec succès',
      shipmentUpdated: 'Expédition mise à jour avec succès',
      shipmentCreated: 'Expédition créée avec succès',
      errorLoading: 'Erreur lors du chargement des expéditions',
      noMatchingShipments: 'Aucune expédition ne correspond à vos critères de recherche et de filtrage actuels.',
      createFirstShipment: 'Aucune expédition n\'a encore été créée.'
    },
    
    // Status translations for forms (singular)
    status: {
      pending: 'En attente',
      in_transit: 'En transit',
      out_for_delivery: 'Avec l\'agent de livraison',
      delivered: 'Livré',
      exception: 'Problème signalé',
      returned: 'Retourné à l\'expéditeur'
    },
    
    // Field labels
    fields: {
      id: 'ID',
      trackingNumber: 'Numéro de suivi',
      status: 'Statut',
      origin: 'Origine (Ville)',
      destination: 'Destination (Ville)',
      customer: 'Client',
      driver: 'Agent de livraison',
      weight: 'Poids (kg)',
      dimensions: 'Dimensions',
      value: 'Valeur déclarée',
      description: 'Description du contenu',
      notes: 'Notes additionnelles',
      createdAt: 'Date de création',
      updatedAt: 'Dernière mise à jour',
      estimatedDelivery: 'Livraison estimée',
      actualDelivery: 'Livraison réelle',
      lastUpdated: 'Dernière mise à jour',
      receiverName: 'Nom du destinataire',
      receiverPhone: 'Téléphone du destinataire',
      receiverAddress: 'Adresse de livraison',
      receiverCity: 'Ville',
      receiverCountry: 'Pays',
      receiverPostalCode: 'Code postal',
      zone: 'Zone de livraison'
    },
    
    // Filtering and searching
    filter: {
      all: 'Toutes les expéditions',
      today: 'Aujourd\'hui',
      thisWeek: 'Cette semaine',
      thisMonth: 'Ce mois',
      dateRange: 'Plage de dates',
      status: 'Filtrer par statut',
      customer: 'Filtrer par client',
      driver: 'Filtrer par chauffeur',
      applyFilters: 'Appliquer les filtres',
      clearFilters: 'Effacer les filtres',
      statusLabel: 'Statut',
      searchPlaceholder: 'Rechercher des expéditions...',
      filters: {
        status: 'Statut',
        all: 'Tous les statuts'
      }
    },
    
    // Tracking functionality
    tracking: {
      title: 'Suivre l\'expédition',
      enterTrackingNumber: 'Entrez le numéro de suivi',
      track: 'Suivre',
      status: 'Statut',
      currentLocation: 'Localisation actuelle',
      estimatedDelivery: 'Livraison estimée',
      history: 'Historique de suivi',
      noHistory: 'Aucun historique de suivi disponible',
      timestamp: 'Horodatage',
      event: 'Événement',
      notes: 'Notes'
    }
  },

  // Zones module
  zones: {
    title: 'Zones d\'expédition',
    createNew: 'Nouvelle zone',
    editZone: 'Modifier la zone',
    
    // Field labels
    fields: {
      id: 'ID',
      name: 'Nom de la zone',
      region: 'Région',
      pricePerKg: 'Prix par kg',
      createdAt: 'Créé le',
      updatedAt: 'Mis à jour le'
    },
    
    // Regions
    regions: {
      national: 'National',
      westAfrica: 'Afrique de l\'Ouest',
      centralAfrica: 'Afrique centrale',
      international: 'International'
    },
    
    // Placeholders
    placeholders: {
      name: 'ex: Ouagadougou Local, Ghana International'
    },
    
    // Statistics
    stats: {
      total: 'Total des zones',
      national: 'Zones nationales',
      international: 'Zones internationales',
      averagePrice: 'Prix moyen'
    },
    
    // Messages
    messages: {
      loading: 'Chargement des zones...',
      error: 'Erreur lors du chargement des zones',
      noZones: 'Aucune zone trouvée',
      created: 'Zone créée avec succès',
      updated: 'Zone mise à jour avec succès',
      deleted: 'Zone supprimée avec succès',
      createError: 'Échec de la création de la zone',
      updateError: 'Échec de la mise à jour de la zone',
  },
  
  // Address types
  addressType: {
    billing: 'Facturation',
    shipping: 'Livraison',
    both: 'Les Deux'
  },

  // Customers module
  customers: {
    title: 'Clients',
    createNew: 'Nouveau Client',
    createCustomer: 'Créer un Client',
    editCustomer: 'Modifier le Client',
    searchPlaceholder: 'Rechercher des clients...',
    noCustomers: 'Aucun client trouvé',
    noSearchResults: 'Aucun client ne correspond à votre recherche',
    
    // Field labels
    fields: {
      id: 'ID',
      user: 'Compte Utilisateur',
      companyName: 'Nom de l\'Entreprise',
      contactPerson: 'Personne de Contact',
      phone: 'Numéro de Téléphone',
      alternatePhone: 'Téléphone Alternatif',
      email: 'Email',
      website: 'Site Web',
      status: 'Statut',
      notes: 'Notes',
      totalShipments: 'Total des Expéditions',
      totalSpent: 'Total Dépensé',
      lastShipment: 'Dernière Expédition',
      createdAt: 'Créé le',
      updatedAt: 'Mis à jour le',
      addressType: 'Type d\'Adresse',
      addressLabel: 'Libellé de l\'Adresse',
      addressLine1: 'Ligne d\'Adresse 1',
      addressLine2: 'Ligne d\'Adresse 2',
      city: 'Ville',
      state: 'État/Province',
      postalCode: 'Code Postal',
      country: 'Pays'
    },
    
    // Status options
    status: {
      active: 'Actif',
      inactive: 'Inactif',
      suspended: 'Suspendu'
    },
    
    // Address types
    addressType: {
      billing: 'Facturation',
      shipping: 'Livraison',
      both: 'Les Deux'
    },
    
    // Statistics
    stats: {
      totalCustomers: 'Total des Clients',
      activeCustomers: 'Clients Actifs',
      inactiveCustomers: 'Clients Inactifs',
      totalRevenue: 'Chiffre d\'Affaires Total',
      averageOrderValue: 'Valeur Moyenne des Commandes'
    },
    
    // Sections
    sections: {
      companyInfo: 'Informations de l\'Entreprise',
      statistics: 'Statistiques du Client',
      addresses: 'Adresses',
      shipmentHistory: 'Historique des Expéditions'
    },
    
    // Actions
    addAddress: 'Ajouter une Adresse',
    editAddress: 'Modifier l\'Adresse',
    defaultAddress: 'Par Défaut',
    noAddresses: 'Aucune adresse trouvée',
    noShipments: 'Aucune expédition trouvée',
    
    // Messages
    messages: {
      created: 'Client créé avec succès',
      updated: 'Client mis à jour avec succès',
      deleted: 'Client supprimé avec succès',
      addressAdded: 'Adresse ajoutée avec succès',
      addressUpdated: 'Adresse mise à jour avec succès',
      addressDeleted: 'Adresse supprimée avec succès',
      loadError: 'Échec du chargement des données client',
      shipmentsLoadError: 'Échec du chargement des expéditions du client',
      createError: 'Échec de la création du client',
      updateError: 'Échec de la mise à jour du client',
      deleteError: 'Échec de la suppression du client',
      addressAddError: 'Échec de l\'ajout de l\'adresse',
      addressUpdateError: 'Échec de la mise à jour de l\'adresse',
      addressDeleteError: 'Échec de la suppression de l\'adresse',
      loadUsersError: 'Échec du chargement des utilisateurs',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer {{name}} ?',
      notFound: 'Client non trouvé',
      error: 'Erreur lors du chargement des clients'
    }
  },
  // Access control translations
  access: {
    denied: 'Accès Refusé',
    driverRestriction: 'En tant que chauffeur, vous ne pouvez accéder qu\'au tableau de bord et aux pages de gestion des chauffeurs. Les autres pages sont réservées aux administrateurs uniquement.',
    allowedPages: 'Pages autorisées',
    goToDashboard: 'Aller au Tableau de Bord'
  },

  // CRUD translations (top-level for components using t('crud.*'))
  crud: {
    create: 'Créer',
    actions: 'Actions',
    edit: 'Modifier',
    delete: 'Supprimer',
    cannotDeleteAdmin: 'Impossible de supprimer un utilisateur administrateur'
  }
};

export default frTranslations;
*/
